var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 21,
    viewBox: "0 0 13 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99994 21.0002C2.73673 21.0017 2.4758 20.9512 2.23213 20.8517C1.98845 20.7522 1.76682 20.6055 1.57994 20.4202C1.39248 20.2342 1.24369 20.013 1.14216 19.7693C1.04062 19.5256 0.988342 19.2642 0.988342 19.0002C0.988342 18.7362 1.04062 18.4747 1.14216 18.231C1.24369 17.9873 1.39248 17.7661 1.57994 17.5802L8.19994 11.0002L1.83994 4.38017C1.46744 4.00545 1.25835 3.49854 1.25835 2.97017C1.25835 2.4418 1.46744 1.9349 1.83994 1.56017C2.02587 1.37272 2.24707 1.22393 2.49079 1.12239C2.7345 1.02085 2.99592 0.968576 3.25994 0.968576C3.52396 0.968576 3.78537 1.02085 4.02909 1.12239C4.27281 1.22393 4.49401 1.37272 4.67994 1.56017L12.3999 9.56017C12.7664 9.93403 12.9717 10.4367 12.9717 10.9602C12.9717 11.4837 12.7664 11.9863 12.3999 12.3602L4.39994 20.3602C4.22042 20.554 4.00427 20.7104 3.76398 20.8203C3.52368 20.9301 3.264 20.9913 2.99994 21.0002Z",
    fill: "#3671E9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.15d81e56c0bd30207de2ffd84b605534.svg";
export { ForwardRef as ReactComponent };